import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail } from "lucide-react";
import { memberApi } from "../api/member";
import { pageRoutes } from "../utils";

const genericMessage =
  "If an account exists for that email, a password reset link has been sent.";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    setStatus("loading");
    setMessage("");
    try {
      const payload = await memberApi("/api/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify({ email }),
      });
      setStatus("success");
      setMessage(payload.message || genericMessage);
    } catch {
      setStatus("success");
      setMessage(genericMessage);
    }
  }

  return (
    <div className="min-h-screen bg-[#FDF8F3] px-4 py-16">
      <div className="mx-auto max-w-md rounded-3xl border border-[#C9A227]/20 bg-white p-8 shadow-sm">
        <div className="flex items-center gap-3">
          <Mail className="h-7 w-7 text-[#722F37]" />
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.22em] text-[#A88520]">
              Account help
            </p>
            <h1 className="font-serif-elegant text-3xl font-bold text-[#722F37]">
              Reset your password
            </h1>
          </div>
        </div>

        {message && (
          <div className="mt-6 rounded-2xl border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-900">
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="mt-8 space-y-5">
          <label className="block">
            <span className="mb-2 block text-sm font-medium text-gray-700">
              Email
            </span>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="w-full rounded-xl border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#C9A227]"
              autoComplete="email"
              required
            />
          </label>

          <button
            type="submit"
            disabled={status === "loading"}
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#722F37] px-5 py-3 font-semibold text-white hover:bg-[#5A252C] disabled:opacity-70"
          >
            {status === "loading" ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Mail className="h-4 w-4" />
            )}
            Send reset link
          </button>
        </form>

        <div className="mt-6 flex flex-wrap justify-center gap-4 text-sm">
          <Link className="font-semibold text-[#722F37] underline" to={pageRoutes.MemberLogin}>
            Member login
          </Link>
          <Link className="font-semibold text-[#722F37] underline" to={pageRoutes.AdminLogin}>
            Admin login
          </Link>
        </div>
      </div>
    </div>
  );
}
